import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=b4155196"
import script from "./invoices.ts?vue&type=script&lang=js&external"
export * from "./invoices.ts?vue&type=script&lang=js&external"
import style0 from "./invoices.vue?vue&type=style&index=0&id=b4155196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports